import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "5",
  height: "10",
  viewBox: "0 0 5 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "m0 10 5-5-5-5z"
    }, null, -1)
  ]));
}
const CaretRight = { render };
export {
  CaretRight as default,
  render
};
//# sourceMappingURL=CaretRight.svg.js.map
